import React, { useState } from "react";
import { Box, Button, Divider, Stack, Typography } from "@mui/material";
import { DataGrid } from "@mui/x-data-grid";

function DiscountValueSection() {
	const [discounts, setDiscounts] = useState([]);

	const handleAddRow = () => {
		const newId = discounts.length ? discounts[discounts.length - 1].id + 1 : 1;
		const newRow = { id: newId, buy: 0, get: 0 };
		setDiscounts((prev) => [...prev, newRow]);
	};

	const handleRowUpdate = (newRow) => {
		const updatedRows = discounts.map((row) => (row.id === newRow.id ? newRow : row));
		setDiscounts(updatedRows);
		return newRow; // Required by DataGrid
	};

	const columns = [
		{
			field: "buy",
			headerName: "BUY Value",
			editable: true,
			type: "number",
			align: "center",
			headerAlign: "center",
			flex: 1,
		},
		{
			field: "get",
			headerName: "GET Value",
			editable: true,
			type: "number",
			align: "center",
			headerAlign: "center",
			flex: 1,
		},
	];

	return (
		<Box width="80%" p={3}>
			<Stack direction="row" justifyContent="space-between" alignItems="center" mb={2}>
				<Typography variant="h6">Scheme Discount Slab</Typography>
				<Button variant="contained" onClick={handleAddRow}>
					Add Row
				</Button>
			</Stack>
			<Divider sx={{ mb: 2 }} />
			<DataGrid
				rows={discounts}
				columns={columns}
				autoHeight
				disableColumnMenu
				hideFooter
				processRowUpdate={handleRowUpdate}
				experimentalFeatures={{ newEditingApi: true }}
			/>
		</Box>
	);
}

export default DiscountValueSection;
